import { BUSINESS } from "@/constants/business";
import { useLang } from "@/context/LangContext";
import { STRINGS } from "@/i18n";

export default function Footer() {
  const { lang } = useLang();
  const t = STRINGS[lang];
  return (
    <footer data-testid="footer" className="border-t border-white/10 py-12 pb-28 md:pb-12 px-6 max-w-7xl mx-auto text-neutral-500 text-xs flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-3">
        <span className="serif-disp text-base text-neutral-300">{BUSINESS.brand} <span className="script-accent text-lg text-[#c9933b]">by Mocha</span></span>
        <span>•</span>
        <span>Licensed Massage Therapist (LMT)</span>
        <span>•</span>
        <span>{BUSINESS.city} · Incall &amp; Outcall</span>
      </div>
      <div className="flex items-center gap-4 font-mono">
        <a data-testid="footer-call-link" href={BUSINESS.phoneHref} className="hover:text-neutral-300 transition-colors">{BUSINESS.phoneDisplay}</a>
        <a data-testid="footer-email-link" href={BUSINESS.emailHref} className="hover:text-neutral-300 transition-colors">{BUSINESS.email}</a>
      </div>
      <p className="text-center font-light">{t.footer.rights}</p>
      <a data-testid="footer-owner-link" href="/admin" className="hover:text-neutral-300 transition-colors font-mono">{t.footer.owner}</a>
    </footer>
  );
}
